<template>
  <div
    class="bg-static-warning-mid text-static-default-hi rounded-md flex flex-col gap-8 p-16"
  >
    <p>{{ i18n(translations.paragraph1) }}</p>

    <RevLink class="text-action-default-hi body-2-link" @click="toggleContent">
      {{ i18n(translations.paragraph2title) }}
    </RevLink>

    <p v-if="isOpened">
      {{ i18n(translations.paragraph2) }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevLink } from '@ds/components/Link'

import translations from './NoReplacementWarning.translations'

const i18n = useI18n()
const tracking = useTracking()
const isOpened = ref(false)

onMounted(() => {
  tracking.trackBlockImpression({ name: 'cart_item_no_alternative' })
})

function toggleContent() {
  isOpened.value = !isOpened.value
}
</script>
